import { Component, OnInit } from '@angular/core';
import { MyPropertyService } from 'src/services/my-property';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
    selector: 'app-reject',
    templateUrl: './reject.component.html',
    styleUrls: ['./reject.component.css'],
    standalone: false
})
export class RejectComponent implements OnInit {

  key:string;
  email:string;
  data: any;

  constructor(private _MyPropertyService: MyPropertyService,private route:ActivatedRoute, private toastr:ToasterService) {
    this.route.queryParams.subscribe(params => {
      this.key = params['key'];
      this.email = params['email'];
  });
   }

  ngOnInit() {
    this.reject();
  }

  reject() {
    this._MyPropertyService.reject(this.key,this.email).subscribe(data => {
      this.toastr.Info(data);
    });
  }

}
